import { useEnvironment } from "@aviv-unified-frontend/runtime/environment";
import { isIOSSafari } from "../utils/isIOSSafari";
import { BRAND_CONFIGURATION } from "../../../../configs/brands";
export const useShouldLoadCustomBanner = () => {
    const { application: { id: applicationId }, } = useEnvironment();
    if (!applicationId)
        return false;
    /**
     * The banner must not be displayed on the Classified Details Page (CDP) for users on iOS mobile Safari to avoid conflicts with App Clips.
     */
    if (applicationId === "app_cldp" && isIOSSafari())
        return false;
    return Boolean(BRAND_CONFIGURATION.appBanner?.custom?.[applicationId]);
};
